import React from 'react';
import { UseFormGetValues, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import { MdAdd, MdRemove } from 'react-icons/md';

import { DecrementButton, ErrorMessage, IncrementButton, Input, InputContainer } from './styleGuide';
import { defaultColors, defaultButton } from '../../../styles/style-guide';

import { useAppSelector } from '../../../hooks/hooksRedux';
import { RootState } from '../../../store';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  error?: string;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  register: UseFormRegister<any>;
  lessDisabled?: boolean;
}

const CustomInputNumber = ({ id, error, register, setValue, getValues, lessDisabled, ...rest }: Props) => {
  const { colors, button } = useAppSelector((state: RootState) => state.styleGuide.data);

  const primaryColor = colors.primary || defaultColors.primary;
  const borderColor = 'transparent';
  const buttonColor = button.primary || defaultButton.primary;

  function increment() {
    if (!rest.disabled) {
      const newCount = parseInt(getValues(id)) + 1;
      setValue(id, newCount);
    }
  }

  function decrement() {
    if (parseInt(getValues(id)) > 0 && !rest.disabled) {
      const newCount = parseInt(getValues(id)) - 1;
      setValue(id, newCount);
    }
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    const pattern = /[0-9]/;
    if (!pattern.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault(); // Impede a entrada de caracteres não numéricos
    }
  }

  return (
    <InputContainer>
      <Input
        {...register(id)}
        {...rest}
        id={id}
        onKeyDown={handleKeyDown}
        $borderColor={borderColor}
        $focusColor={primaryColor}
        type="number"
      />
      <IncrementButton $backgroundColor={buttonColor} type="button" onClick={increment}>
        <MdAdd color="#fff" size={20} />
      </IncrementButton>
      <DecrementButton
        $color={primaryColor}
        $backgroundColor={buttonColor}
        color={primaryColor}
        type="button"
        onClick={decrement}
        disabled={!!lessDisabled}
      >
        <MdRemove color="#fff" size={20} />
      </DecrementButton>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputContainer>
  );
};

export { CustomInputNumber };
